import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tab } from 'foundations-components/transitional/components/Tabs';
import { Tabs } from 'foundations-components/transitional/components/Tabs';
import { Header } from 'foundations-components/transitional/components/Header';
import { useAnalyticsSuiteNavigation } from '../hooks/useAnalyticsSuiteNavigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AnalyticsSuiteHeader = () => {
  const {
    activeTabId,
    navigateToTab,
    tabConfig
  } = useAnalyticsSuiteNavigation();
  return /*#__PURE__*/_jsx(Header, {
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-400",
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartLibrary.analyticsSuite.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartLibrary.analyticsSuite.subTitle"
        })
      })]
    }),
    tabs: /*#__PURE__*/_jsx(Tabs, {
      selected: activeTabId,
      children: tabConfig.map(({
        icon,
        tabId,
        titleKey,
        accessProperties
      }) => /*#__PURE__*/_jsx(Tab, {
        icon: icon,
        tabId: tabId,
        title: I18n.text(titleKey),
        onClick: () => navigateToTab(tabId),
        disabled: !accessProperties.accessAllowed
      }, tabId))
    })
  });
};